import { AxiosResponse, AxiosStatic } from "axios";
import { ICreationResponse } from "../../parsers/resolve";
import { IFontsApi, IFontsApiDependencies, IFullFontBody, IFullFontResponse } from "./types";

export default class FontsApi implements IFontsApi {
  private readonly apiRoot: string;
  private readonly axios: AxiosStatic;

  constructor(dependencies: IFontsApiDependencies) {
    this.apiRoot = dependencies.saltcomplianceApiRoot;
    this.axios = dependencies.axios;
  }

  public create = (
    font: IFullFontBody,
    accountId: string
  ): Promise<AxiosResponse<ICreationResponse<IFullFontResponse>>> => {
    return this.axios.post(`${this.apiRoot}/fontFamilies`, font, {
      params: { activeUser: accountId },
    });
  };

  public getEditableByRelativeTo = (accountId: string, organizationId: string): Promise<AxiosResponse<string[]>> => {
    return this.axios.get(
      `${this.apiRoot}/collections/fontFamilies/editableBy/${accountId}/relativeToOrg/${organizationId}`,
      {
        params: { activeUser: accountId },
      }
    );
  };
}
